import LeanPayPage from './LeanPayPage';

export default LeanPayPage;
